// @ts-nocheck
import { BankOutlined, EditOutlined } from "@ant-design/icons";
import {
  App,
  Button,
  Flex,
  Space,
  theme,
  Typography,
} from "antd";
import { useState } from "react";
import { getCardBankName } from "../../utils/digits.js";
import BankLogo from "../bankLogo.js";
import FinancialInfoEdit from "./financialInfoEdit.js";
import InfoRow from "./InfoRow.js";
import Card from "../Card.js";
import useUser from "/src/hooks/useUser.js";

const FinancialInfoCard = () => {
  const [isEditing, setIsEditing] = useState(false);
  const { message } = App.useApp();
  const {
    token: { colorBgContainer, colorPrimary },
  } = theme.useToken();
  const { data, isLoading: loading, mutate } = useUser();

  const handleEdit = () => {
    if (!data?.isPhoneVerified) {
      return message.error("شماره همراه شما تایید نشده است");
    }
    if (!data?.isNationalCodeVerified) {
      return message.error("کد ملی شما تایید نشده است");
    }
    setIsEditing(true);
  };

  const handleEditSuccess = () => {
    mutate(); // Refresh data after successful edit
  };

  if (loading) return null;


  return (
    <Card
      title="اطلاعات بانکی"
      Icon={BankOutlined}
      actions={<Button onClick={handleEdit}
        size="small"
        icon={<EditOutlined />}>
        ویرایش
      </Button>}>

      {isEditing ? (
        <FinancialInfoEdit
          data={data}
          onCancel={() => setIsEditing(false)}
          onSuccess={handleEditSuccess}
        />
      ) : (
        <>
          <Space className="mt-4" direction="vertical" size="middle">
            <InfoRow label="شماره شبا" value={data?.bankAccount?.sheba ? `IR${data.bankAccount.sheba}` : "-"} />
            <InfoRow label="شماره کارت" value={data?.bankAccount?.cardNumber || "-"} />
            {data?.bankAccount?.cardNumber && (
              <InfoRow label="بانک" value={
                <Flex align="center" gap={4}>
                  <BankLogo name={getCardBankName(data?.bankAccount?.cardNumber)} size="sm" />
                  <Typography.Text className="font-bold">{getCardBankName(data?.bankAccount?.cardNumber)}</Typography.Text>
                </Flex>
              } />
            )}
          </Space>
        </>
      )}
    </Card>
  )
};

export default FinancialInfoCard;
